import patient from './patient'
import doctor from './doctor'
import basket from './basket'
import search from './search'

const reducers = {patient, doctor, basket, search}

export default reducers
